module.exports = __webpack_public_path__ + "img/close.56675286.svg";